// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useContext } from 'react';
import styled from 'styled-components';
import MemberContext from '../contexts/MemberContext';

const S = {
  Container: styled.div`
    width: 41px;
    height: 41px;
    border-radius: 100%;
    overflow: hidden;
    border: 3px solid transparent;
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    letter-spacing: 0.59px;

    &:hover, &:active {
      border-color: #DFDFDF;
    }
  `,
  Avatar: styled.div<{ image: string }>`
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${props => props.image});
  `,
  Title: styled.p`
    text-transform: uppercase;
    color: #FFFFFF;
    text-align: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    letter-spacing: 0.59px;
  `,
  UserPictureBlank: styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    background: #FCA032;
    font-size: 24px;
  `
}

const Avatar: React.FC<ComponentPropsWithRef<'div'>> = (props) => {
  const member = useContext(MemberContext)

  return (
    <S.Container {...props}>
      {
        member.imageUrl ?
          (<S.Avatar image={member.imageUrl}></S.Avatar>) : <S.UserPictureBlank>{member.email[0].toUpperCase()}</S.UserPictureBlank>
      }
    </S.Container>
  )
}

export { Avatar as default, S };
